import getters from './getters';
import actions from './actions';
import mutations from './mutations';

var state = () => ({
  user: null
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};